(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("Dealer", [
    "$rootScope",
    "localstorage",
    "cookies",
    function ($rootScope, localstorage, cookies) {
      var PREV_DEALER_SAVED_LOCAL_STORAGE_KEY = "prev_saved_dealer_information";
      var PREV_DEALER_DEFAULT_LOCAL_STORAGE_KEY = "prev_default_dealer_information";
      var DEALER_SAVED_LOCAL_STORAGE_KEY = "saved_dealer_information";
      var DEALER_DEFAULT_LOCAL_STORAGE_KEY = "default_dealer_information";
      var DEALER_SAVED_FALLBACK_TO_DEFAULT_COOKIE_KEY = "dealer";
      var PREV_DEALER_SAVED_FALLBACK_TO_DEFAULT_COOKIE_KEY = "prev_dealer";

      var PREV_DEALER_KEY_DEFAULT = "prev_default";
      var PREV_DEALER_KEY_SAVED = "prev_saved";
      var DEALER_KEY_DEFAULT = "default";
      var DEALER_KEY_SAVED = "saved";

      var emptyDealer = {
        address: "",
        branchCode: "",
        city: "",
        dealerCode: "",
        email: "",
        name: "",
        postCode: "",
        region: "",
        state: "",
        telephone: "",
        orderAndCollectFlag: false,
        orderAndCollectURL: "",
      };

      /*
       * internal state
       * this is used to handle not having localstorage working
       * if something else writes to this localstorage location, we don't support picking that up until a page reload
       */

      var dealers = {};
      dealers[PREV_DEALER_KEY_DEFAULT] = angular.copy(emptyDealer);
      dealers[PREV_DEALER_KEY_SAVED] = angular.copy(emptyDealer);
      dealers[DEALER_KEY_DEFAULT] = angular.copy(emptyDealer);
      dealers[DEALER_KEY_SAVED] = angular.copy(emptyDealer);

      function dealerToCookieObject(dealer) {
        return {
          p: dealer.postCode,
          s: dealer.city,
          st: dealer.state,
          r: dealer.region,
          n: dealer.name,
        };
      }

      function update(dealer, localStorageKey, didSetCookiesCallback) {
        dealers[localStorageKey] = dealer;

        var oldSavedWithFallback = JSON.stringify(getSavedFallbackToDefault());

        localstorage.set(localStorageKey, angular.copy(dealer));
        cookies.set(DEALER_SAVED_FALLBACK_TO_DEFAULT_COOKIE_KEY, dealerToCookieObject(getSavedFallbackToDefault()));
        didSetCookiesCallback();

        var newSavedWithFallback = JSON.stringify(getSavedFallbackToDefault());
        if (oldSavedWithFallback !== newSavedWithFallback) {
          triggerSavedDealerWithDefaultFallbackDidChange();
        }
      }

      function updatePrevSavedDealerState(defaultDealer, savedDealer) {
        dealers[PREV_DEALER_KEY_DEFAULT] = angular.copy(defaultDealer);
        dealers[PREV_DEALER_KEY_SAVED] = angular.copy(savedDealer);

        localstorage.set(PREV_DEALER_DEFAULT_LOCAL_STORAGE_KEY, angular.copy(defaultDealer));
        localstorage.set(PREV_DEALER_SAVED_LOCAL_STORAGE_KEY, angular.copy(savedDealer));

        cookies.set(PREV_DEALER_SAVED_FALLBACK_TO_DEFAULT_COOKIE_KEY, dealerToCookieObject(savedDealer));
      }

      function getSavedFallbackToDefault() {
        var savedDealer = get(DEALER_KEY_SAVED, DEALER_SAVED_LOCAL_STORAGE_KEY);
        var defaultDealer = get(DEALER_KEY_DEFAULT, DEALER_DEFAULT_LOCAL_STORAGE_KEY);

        if (savedDealer.name !== "") {
          return savedDealer;
        }

        return defaultDealer;
      }

      function getDealerFromLocalStorage(localStorageKey) {
        if (localstorage.exists(localStorageKey)) {
          var localstorageDealer = localstorage.get(localStorageKey);

          // remove the localstorage expiry date
          delete localstorageDealer.expiry;

          return localstorageDealer;
        }

        return angular.copy(emptyDealer);
      }

      function revertToPrevSavedDealerState() {
        var prevDefaultDealer = get(PREV_DEALER_KEY_DEFAULT, PREV_DEALER_DEFAULT_LOCAL_STORAGE_KEY);
        var prevSavedDealer = get(PREV_DEALER_KEY_SAVED, PREV_DEALER_SAVED_LOCAL_STORAGE_KEY);

        update(prevDefaultDealer, DEALER_DEFAULT_LOCAL_STORAGE_KEY, triggerDefaultDealerDidChange);
        update(prevSavedDealer, DEALER_SAVED_LOCAL_STORAGE_KEY, triggerSavedDealerDidChange);

        dealers[PREV_DEALER_KEY_DEFAULT] = angular.copy(emptyDealer);
        dealers[PREV_DEALER_KEY_SAVED] = angular.copy(emptyDealer);
        localstorage.set(PREV_DEALER_DEFAULT_LOCAL_STORAGE_KEY, angular.copy(emptyDealer));
        localstorage.set(PREV_DEALER_SAVED_LOCAL_STORAGE_KEY, angular.copy(emptyDealer));
      }

      function get(internalKey, localStorageKey) {
        // internal state takes precedence, if it's there
        if (dealers[internalKey].name !== "") {
          return dealers[internalKey];
        }

        // get the data from localstorage
        return getDealerFromLocalStorage(localStorageKey);
      }

      function triggerSavedDealerDidChange() {
        $rootScope.$broadcast("dealer-saved-did-change", dealers[DEALER_KEY_SAVED]);
      }

      function triggerDefaultDealerDidChange() {
        $rootScope.$broadcast("dealer-default-did-change", dealers[DEALER_KEY_DEFAULT]);
      }

      function triggerSavedDealerWithDefaultFallbackDidChange() {
        $rootScope.$broadcast("saved-dealer-with-default-fallback-did-change", getSavedFallbackToDefault());
      }

      // Set the internal state based on the localstorage, if there's anything
      dealers[PREV_DEALER_KEY_SAVED] = getDealerFromLocalStorage(PREV_DEALER_SAVED_LOCAL_STORAGE_KEY);
      dealers[PREV_DEALER_KEY_DEFAULT] = getDealerFromLocalStorage(PREV_DEALER_DEFAULT_LOCAL_STORAGE_KEY);
      dealers[DEALER_KEY_DEFAULT] = getDealerFromLocalStorage();

      return {
        clearSaved: function () {
          update(emptyDealer, DEALER_SAVED_LOCAL_STORAGE_KEY, triggerSavedDealerDidChange);
        },
        updateSaved: function (dealer) {
          update(dealer, DEALER_SAVED_LOCAL_STORAGE_KEY, triggerSavedDealerDidChange);
        },
        updateDefault: function (dealer) {
          update(dealer, DEALER_DEFAULT_LOCAL_STORAGE_KEY, triggerDefaultDealerDidChange);
        },
        updatePrevSaved: updatePrevSavedDealerState,
        revertToPrevSaved: revertToPrevSavedDealerState,
        getPrevSaved: function () {
          return get(PREV_DEALER_KEY_SAVED, PREV_DEALER_SAVED_LOCAL_STORAGE_KEY);
        },
        getSaved: function () {
          return get(DEALER_KEY_SAVED, DEALER_SAVED_LOCAL_STORAGE_KEY);
        },
        getPrevDefault: function () {
          return get(PREV_DEALER_KEY_DEFAULT, PREV_DEALER_DEFAULT_LOCAL_STORAGE_KEY);
        },
        getDefault: function () {
          return get(DEALER_KEY_DEFAULT, DEALER_DEFAULT_LOCAL_STORAGE_KEY);
        },
        getSavedFallbackToDefault: getSavedFallbackToDefault,
      };
    },
  ]);
})(window.angular);
